import {
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  Output,
  TemplateRef,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { ResponsivenessService } from '@coin/shared/core/feature-state';
import { TinyHelpers } from '@coin/shared/core/util-helpers';
import { ListColumn } from '@coin/shared/core/util-models';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-c-list-header',
  templateUrl: './list-header.component.html',
  styleUrls: ['./list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgStyle,
    NgTemplateOutlet,
    MatIcon,
    MatTooltip,
    V2ButtonComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    TranslatePipe
  ]
})
export class ListHeaderComponent {
  responsive = inject(ResponsivenessService);

  @Input() leftTemplate: TemplateRef<unknown>;
  @Input() rightTemplate: TemplateRef<unknown>;
  columns = input<ListColumn[]>();
  columnScaleFactor = input(1);
  @Input() translationPrefix: string;
  @Input() background: string;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onAction: EventEmitter<string> = new EventEmitter<string>();

  scaledColumnWidths = computed(() => {
    const scaleFactor = this.columnScaleFactor();

    return this.columns()
      ?.map(column => this.scaleWidth(column.width, scaleFactor))
      .join(' ');
  });

  private scaleWidth(width: string, factor: number): string {
    const floatingPointNumber = /[+-]?([0-9]*[.])?[0-9]+/g;
    return width.replaceAll(floatingPointNumber, matchedNumber => {
      return (Number.parseFloat(matchedNumber) * factor).toString();
    });
  }

  public get isTranslationPrefixGiven(): boolean {
    return this.translationPrefix?.trim().length > 0;
  }

  firstNamedIndex = computed(() => {
    return this.columns().findIndex(column => !!column.name);
  });

  lastNamedIndex = computed(() => {
    return TinyHelpers.findLastIndex(this.columns(), column => !!column.name);
  });

  public pascalcaseToKebabCase = TinyHelpers.pascalcaseToKebabCase;

  public onActionClick(action: string): void {
    this.onAction.emit(action);
  }
}
